@if (isOpen() && config()) {
<div class="fixed inset-0 z-50 flex items-center justify-center">
  <div
    class="fixed inset-0 bg-surface-bg-generic-black opacity-20"
    role="button"
    tabindex="0"
    (click)="config()?.closeOnOverlayClick ? close() : null"></div>

  <div
    class="relative bg-white rounded-lg max-w-md mx-4 max-h-[90dvh] overflow-x-hidden overflow-y-auto"
    style="box-shadow: 0px 6px 16px -2px #10182814"
    [ngClass]="config()?.modalClass ?? defaultModalClass">
    @if (config()?.showCloseButton) {
    <lib-button
      [id]="'close-btn'"
      (click)="close()"
      [size]="'xlg'"
      [btnClass]="'absolute top-measure-xlg end-measure-xlg'">
      <lib-close-icon
        slot="end-icon"
        [width]="'20px'"
        [height]="'20px'"
        [viewBox]="'0 0 20 20'" />
    </lib-button>
    }

    <!-- Icon Section with standardized styling -->
    <div class="flex justify-center items-center mb-8">
      @if (config()?.iconSvg) {
      <!-- Custom icon template override -->
      <ng-container *ngTemplateOutlet="config()?.iconSvg"></ng-container>
      } @else {
      <!-- Default icons based on modal type -->
      @switch (config()?.type) { @case ('delete') {
      <div
        class="flex items-center justify-center w-measure-7xl h-measure-7xl bg-surface-bg-destructive-faint rounded-full">
        <lib-delete-icon [color]="'#EF4444'" />
      </div>
      } @case ('info') {
      <div
        class="flex items-center justify-center w-measure-7xl h-measure-7xl bg-surface-bg-destructive-faint rounded-full">
        <lib-info-icon [color]="'#EF4444'" />
      </div>
      } @case ('warning') {
      <div
        class="flex items-center justify-center w-20 h-20 bg-orange-50 rounded-full">
        <lib-warning-icon width="48" height="48" [color]="'#F97316'" />
      </div>
      } @case ('error') {
      <div
        class="flex items-center justify-center w-20 h-20 bg-red-50 rounded-full">
        <lib-outlined-close-icon width="48" height="48" [color]="'#EF4444'" />
      </div>
      } @case ('primary') {
      <div
        class="flex items-center justify-center w-12 h-12 bg-blue-50 rounded-full">
        <lib-check-icon
          [color]="'var(--color-primary-500)'"
          [width]="'24'"
          [height]="'24'" />
      </div>
      } } }
    </div>

    <!-- Title and Message with standardized styling -->
    <div class="flex flex-col gap-2 justify-center items-center">
      @if (config()?.title) {
      <h6
        class="text-center font-semibold text-[--text-font-size-paragraph-md] leading-[--leading-line-height-label-large] tracking-[--tracking-letter-spacing-label-lg]">
        {{ config()?.title }}
      </h6>
      } @if (config()?.message) {
      <p
        class="text-center font-normal text-typography-neutral-primary text-[--text-font-size-label-md] leading-[--leading-line-height-label-medium] tracking-[--tracking-letter-spacing-label-md]">
        {{ config()?.message }}
      </p>
      }
    </div>

    <ng-container
      *ngTemplateOutlet="config()?.template; context: { $implicit: config()?.data }"></ng-container>

    <!-- Actions with standardized styling -->
    @if (config()?.actions?.length) {
    <div
      class="flex flex-col justify-center gap-3"
      [ngClass]="config()?.actionsClass ?? 'mt-8'">
      @for (action of config()?.actions; track action.label) {
      <lib-button
        [id]="'action-btn'"
        [label]="typeof action.label === 'function' ? action.label() : action.label"
        [size]="'md'"
        [btnClass]="action?.btnClass ?? ''"
        (click)="action.onClick()">
      </lib-button>
      }
    </div>
    }
  </div>
</div>
}
